import { REMOVE_WAIT_LIST_ID, SET_WAIT_LIST_ID } from '../actions/actionTypes';

const initialState: number = 0;

export const driverWaitingReducer = (state: number = initialState, action: any) => {

  switch (action.type) {

    case SET_WAIT_LIST_ID:
      return action.data;
    default:
      return state;
  }
};